import {SelectableObject} from "@k/js/selectableObjects";

export function filterOutClones(selObList:SelectableObject[]) {
    return selObList.reduce(function(carry, l) {
        if(carry.cloneIds.indexOf(l.id) >-1) {
            return carry;
        }
        carry.cloneIds = carry.cloneIds.concat(l.cloneIds);
        carry.notClones.push(l);
        return carry;
    }, {cloneIds:[] as string[], notClones:[] as SelectableObject[]}).notClones;
}